import { Capacitor } from "@capacitor/core";

export type PlatformName = "android" | "ios" | "web";

// Debug-only override: stick a value in localStorage under this key and
// reload to simulate running on iOS/Android from a web browser. Only affects
// code that goes through this module (isHybridApp/isIOS/isAndroid/PLATFORM);
// native Capacitor plugins themselves still report the real platform.
export const DEBUG_PLATFORM_OVERRIDE_KEY = "debug-platform-override";

const readOverride = (): PlatformName | null => {
  try {
    const raw = localStorage.getItem(DEBUG_PLATFORM_OVERRIDE_KEY);
    return raw === "ios" || raw === "android" || raw === "web" ? raw : null;
  } catch {
    return null;
  }
};

const override = readOverride();

// Raw Capacitor checks — never affected by the debug override. Use these to
// gate real Capacitor plugin calls that would throw "Not implemented on web"
// when the override is simulating native from a browser.
export const IS_REALLY_NATIVE = Capacitor.isNativePlatform();
export const REAL_PLATFORM = Capacitor.getPlatform() as PlatformName;

export const isReallyNative = (): boolean => IS_REALLY_NATIVE;

export const PLATFORM_IS_NATIVE =
  override === "ios" || override === "android"
    ? true
    : override === "web"
      ? false
      : IS_REALLY_NATIVE;

export const PLATFORM: PlatformName = override ?? REAL_PLATFORM;
